<template>
<div class="chapter">
<div class="inner_page">
<h2 id="toc" title="Cover"></h2>
<p class="ImageCentred"><img alt="Excellence in Preaching - Learning from the best" src="Images/9780830863822.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?35b6d9ea